import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import styled, { css } from 'styled-components';
import { Text, Wrapper } from 'components';
import { selectSite } from 'store/Site';
import { IEmployerSite, PermissionType } from 'types';
import { hasSitePermission } from 'utils';
import { SettingCardContainer, StyledIconButton, TipCalculationsContainer } from '../../../styles';
import { TipCalculationsDescription } from '../../shared/styles';
import { CreditCardFeesForm } from './CreditCardFeesForm';
import { CreditCardFeesItem } from './CreditCardFeesItem';

interface ICreditCardFeesProps {
  currentSite: IEmployerSite;
}

// White sub-card in view mode; collapses into the outer container when editing (disabled=false).
const InnerCard = styled(SettingCardContainer)`
  ${({ disabled }) =>
    !disabled &&
    css`
      padding: 0;
      border: none;
      background: transparent;
    `}
`;

export const CreditCardFees: React.FC<ICreditCardFeesProps> = ({ currentSite }) => {
  const siteWithSettings = useSelector(selectSite());
  const [isEditing, setIsEditing] = useState(false);
  const onClose = () => setIsEditing(false);
  const editPermission = hasSitePermission(currentSite?.permissions, PermissionType.CALCULATOR_CREDIT_CARD_FEE_UPDATE);
  const { tipCalculatorPercentFee } = siteWithSettings?.settings || {};

  return (
    <TipCalculationsContainer>
      <InnerCard data-cy="credit-card-fees-settings" $noMargin disabled={!isEditing}>
        <Wrapper direction="row" justifyContent="space-between" width="100%" gap={0} noWrap>
          <Wrapper direction="column" gap={4}>
            <Text size="small" fontWeight="semibold">
              Credit Card Fee Deduction
            </Text>
            <TipCalculationsDescription size="xsmall">Automatically deduct a percentage from all credit card tips and autograts.</TipCalculationsDescription>
          </Wrapper>
          {editPermission && !isEditing && <StyledIconButton label="Edit" appearance="white" icon="Edit" data-cy="edit-button" onClick={() => setIsEditing(true)} />}
        </Wrapper>

        {!isEditing ? <CreditCardFeesItem percentFee={tipCalculatorPercentFee} /> : <CreditCardFeesForm site={siteWithSettings} onClose={onClose} />}
      </InnerCard>
    </TipCalculationsContainer>
  );
};
